import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Chip } from "@mui/material";
import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { GqlWorkerVisitReportStatus } from "~/__generated__";

type Props = {
    status: GqlWorkerVisitReportStatus | "Planned";
};

const STATUS_META: Record<
    GqlWorkerVisitReportStatus | "Planned",
    {
        icon: JSX.Element;
        color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
        labelKey: string;
        defaultLabel: string;
    }
> = {
    ["Planned"]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "secondary",
        labelKey: "projectVisitWorkerStatus.approved",
        defaultLabel: "Planned",
    },
    [GqlWorkerVisitReportStatus.Approved]: {
        icon: <CheckCircleIcon fontSize="small" />,
        color: "success",
        labelKey: "projectVisitWorkerStatus.approved",
        defaultLabel: "Approved",
    },
    [GqlWorkerVisitReportStatus.AwaitingReport]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "error",
        labelKey: "projectVisitWorkerStatus.awaitingReport",
        defaultLabel: "Awaiting Report",
    },
    [GqlWorkerVisitReportStatus.Rejected]: {
        icon: <CancelIcon fontSize="small" />,
        color: "error",
        labelKey: "projectVisitWorkerStatus.rejected",
        defaultLabel: "Rejected",
    },
    [GqlWorkerVisitReportStatus.AwaitingApproval]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "warning",
        labelKey: "projectVisitWorkerStatus.awaitingApproval",
        defaultLabel: "Awaiting Approval",
    },
};

export default function WorkerReportStatusChip({ status }: Props) {
    const { t } = useTranslation("project");
    const current = STATUS_META[status];

    return (
        <Chip
            label={
                <span
                    style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                        maxWidth: "100%",
                    }}
                >
                    {t(current.labelKey, current.defaultLabel)}
                </span>
            }
            icon={current.icon}
            color={current.color}
            size="small"
            sx={{
                maxWidth: "100%",
                flexShrink: 1,
            }}
        />
    );
}
